export const CLAIMS_PROCESSED_DATA_API_URL='claim-metrics/';
export const CLAIMS_METRICS_EXCLUSION_DATA_API_URL='claim-metrics-by-exclusion';
export const CLAIMS_BULK_PROCESS_API_URL='claims-bulk-process-jobs/dos-claim-metrics';
export const CLAIMS_METRICS_EXCLUSION_BULK_PROCESS_API_URL='claims-bulk-process-jobs/claim-metrics-by-exclusion';

export const DOP_CLAIMS_PROCESSED_DATA_API_URL='dop-claim-metrics/';
export const DOP_CLAIMS_BULK_PROCESS_API_URL='claims-bulk-process-jobs/dop-claim-metrics';
export const CLAIMS_PROCESSED_MONTHLY_API_URL='claims-processed-monthly/';
export const CLAIMS_PROCESSED_MONTHLY_BULK_API_URL='claims-bulk-process-jobs/claims-processed-monthly';
